export default __webpack_public_path__ + "static/media/admins.4085d2a3.svg";